module.exports = __webpack_public_path__ + "assets/img/contact_banner.5a8dd8aa.png";